import ButtonCustom from './button';
import ButtonCustomAuth from './button-auth';

const CustomButton = {
    Root: ButtonCustom,
    Auth: ButtonCustomAuth,
    name: 'Button custom with loading',
};

export default CustomButton;
